/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DocumentAdminControllerReconcileOrphanedDocumentsMutationResponse, DocumentAdminControllerReconcileOrphanedDocuments400, DocumentAdminControllerReconcileOrphanedDocuments401, DocumentAdminControllerReconcileOrphanedDocuments403 } from "../../models/documentAdminController/DocumentAdminControllerReconcileOrphanedDocuments";

function getDocumentAdminControllerReconcileOrphanedDocumentsUrl() {
  const res = { method: 'POST', url: `/api/v1/documents/orphaned-document-reconciliations` as const }  
  return res
}

/**
 * @description Admin/service-account endpoint. Marks each orphaned document (and its canonical rendition) DELETED. Pass dryRun=true to preview only. fileIds restricts the run to an approved set; the server re-detects and acts only on the ones still orphaned, reporting the rest as dropped. The response verifies that no targeted orphans remain.
 * @summary Reconcile orphaned ACTIVE documents whose source file is deleted
 * {@link /api/v1/documents/orphaned-document-reconciliations}
 */
export async function documentAdminControllerReconcileOrphanedDocuments(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<DocumentAdminControllerReconcileOrphanedDocumentsMutationResponse, ResponseErrorConfig<DocumentAdminControllerReconcileOrphanedDocuments400 | DocumentAdminControllerReconcileOrphanedDocuments401 | DocumentAdminControllerReconcileOrphanedDocuments403>, unknown>({ method : "POST", url : getDocumentAdminControllerReconcileOrphanedDocumentsUrl().url.toString(), ... requestConfig })  
  return res.data
}